import loadStylesheet from '@fno/lib/load-stylesheet.js'
import template from './Tab.svelte'
import task from './task/task'
import welcome from './welcome/welcome'
import setup from './setup/setup'
import { getSchool } from '@fno/service/api/schools'
import { getTabTool } from '@fno/service/api/tasks'

export default (stateRouter, featureFlags, portalConfig) => {
    const name = 'tab'

    stateRouter.addState({
        name,
        route: '/tab/:schoolId',
        template,
        resolve: async (ignore, { schoolId }) => {
            // NOTE: We use the client onboarding resource in the sidebar menu, so we
            // need to make sure it is loaded at the root of the resolve. (It's probably
            // loaded elsewhere in the routes, but since the request is cached it's not
            // an expensive problem to request it many times.)
            
            // EDIT: The above still might be true, except that the results from these promises
            // are now stored in seperate stores for global access in the TAB to reduce redundant
            // api calls
            const [{ selectedSchool, stepIdToRoute, tier, orgsData  }, tabTool ] = await Promise.all([
                getSchool({ schoolId, include: [ 'orgsData' ] }),
                getTabTool({ schoolId })
            ])

            if (tier === 'tier1') {
                stateRouter.go('app')
            }

            return {
                schoolId,
                portalConfig,
                featureFlags,
                stepIdToRoute,
                tabTool,
                selectedSchool,
                tier,
                orgsData
            }
        },
        defaultChild: 'task',
        activate: () => {
            loadStylesheet()
        }
    })

    setup(name, stateRouter)
    task(name, stateRouter)
    welcome(name, stateRouter)
}
